import cc from "classcat";
import { CSSProperties, ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
  emphasize?: boolean;
  className?: string;
}

function Card(props: CardProps) {
  return (
    <div
      style={{
        width: "100%",
        border: props.emphasize
          ? "1px solid var(--theme-primary)"
          : "1px solid var(--border-color-default)",
        backgroundColor: props.emphasize
          ? "rgba(var(--theme-rgb-primary), var(--alpha-5))"
          : "var(--bgColor-white)",
        ...props.style,
      }}
      className={cc(["border--all rounded--all--m padding--all--l", props.className])}
    >
      {props.children}
    </div>
  );
}

export { Card };
